const ServicesGrid = () => {
  const services = [
    {
      icon: 'ri-lightbulb-line',
      title: 'IT Consulting',
      description: 'Strategic technology guidance to align your IT infrastructure with business objectives and drive digital transformation.',
      color: 'from-purple-500 to-purple-600',
      hoverColor: 'hover:bg-purple-50',
      borderColor: 'hover:border-purple-500',
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Migration',
      description: 'Seamless transition to cloud platforms with minimal disruption, optimizing performance and reducing operational costs.',
      color: 'from-blue-500 to-blue-600',
      hoverColor: 'hover:bg-blue-50',
      borderColor: 'hover:border-blue-500',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Support Services',
      description: 'Comprehensive administrative support, process optimization, and workflow automation to enhance operational efficiency.',
      color: 'from-teal-500 to-teal-600',
      hoverColor: 'hover:bg-teal-50',
      borderColor: 'hover:border-teal-500',
    },
    {
      icon: 'ri-megaphone-line',
      title: 'Advertisement & Marketing Services',
      description: 'Strategic brand development, digital advertising campaigns, and data-driven marketing solutions to grow your business.',
      color: 'from-orange-500 to-orange-600',
      hoverColor: 'hover:bg-orange-50',
      borderColor: 'hover:border-orange-500',
    },
    {
      icon: 'ri-chat-smile-3-line',
      title: 'SMM Management Services',
      description: 'Expert social media strategy, content creation, and community management to build your online presence and engagement.',
      color: 'from-pink-500 to-pink-600',
      hoverColor: 'hover:bg-pink-50',
      borderColor: 'hover:border-pink-500',
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-700 text-sm font-semibold rounded-full mb-4">
            Our Expertise
          </div>
          <h2 className="text-5xl font-bold text-slate-900 mb-4">
            Comprehensive IT Services
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            We deliver end-to-end technology solutions that empower businesses to innovate, scale, and succeed in the digital age.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group bg-white rounded-2xl p-8 shadow-md transition-all duration-300 hover:shadow-xl hover:-translate-y-2 border-b-4 border-transparent ${service.hoverColor} ${service.borderColor} cursor-pointer`}
            >
              <div className={`w-16 h-16 flex items-center justify-center bg-gradient-to-br ${service.color} rounded-2xl mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${service.icon} text-white text-3xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {service.title}
              </h3>
              <p className="text-sm text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/services')}
                className="text-sm font-semibold text-cyan-600 hover:text-cyan-700 flex items-center space-x-2 group-hover:translate-x-2 transition-transform whitespace-nowrap cursor-pointer"
              >
                <span>Learn More</span>
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;